const sliderStagesInit = (block) => {
    const wrappers = block
        ? [block[0].querySelector('.bn-slider-stages')]
        : Array.from(document.querySelectorAll('.bn-slider-stages'));

    if (wrappers) {
        wrappers.forEach((wrapper) => {
            if (!wrapper) return;

            const topEl = wrapper.querySelector('.bn-slider-stages__top');
            const bottomEl = wrapper.querySelector('.bn-slider-stages__bottom');
            if (!topEl || !bottomEl) return;

            const prevBtn = wrapper.querySelector('.bn-slider-stages__btn--prev');
            const nextBtn = wrapper.querySelector('.bn-slider-stages__btn--next');
            const slidesCount = topEl.querySelectorAll('.swiper-slide').length;

            const bottomSlider = new Swiper(bottomEl, {
                observer: true,
                observeSlideChildren: true,
                rewind: true,
                initialSlide: 0,
                slidesPerView: 'auto', 
                spaceBetween: 20,
                centeredSlides: true,
                speed: 400,
                allowTouchMove: false,
            });

            const topSlider = new Swiper(topEl, {
                observer: true,
                observeSlideChildren: true,
                rewind: true,
                initialSlide: 0,
                slidesPerView: 'auto',
                spaceBetween: 240,
                centeredSlides: true,
                speed: 400,
                grabCursor: true,
                breakpoints: {
                    0: {
                        spaceBetween: 80,
                    },
                    1000: {
                        spaceBetween: 240,
                    },
                },
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
            });

            topSlider.on('slideChange', () => {
                bottomSlider.slideTo(topSlider.activeIndex, 400, true);
            });

            topSlider.on('observerUpdate', () => {
                topSlider.update();
                bottomSlider.update();
            });
        });
    }
};

document.addEventListener('DOMContentLoaded', function () {
    if (
        !document.body.classList.contains('block-editor-page') &&
        !document.body.classList.contains('block-editor-iframe__body')
    ) {
        sliderStagesInit();
    } else if (window.acf) {
        window.acf.addAction('render_block_preview/type=bn/slider-stages', sliderStagesInit);
    }
});

